import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';


export const useChoiceListApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const getChoiceList = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getChoicesList(
          query.storeId,
          searchParam
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );



  return {
   getChoiceList,
    loading,
    error,
  };
};
